'use client'

import { FC, useEffect, useState } from 'react'

import { basePath } from '@lib/constants'

const scriptId = 'spec-rules'
const SpeculationRules: FC = () => {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    if (loaded) return
    if (document.getElementById(scriptId)) return
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      const specScript = document.createElement('script')
      specScript.type = 'speculationrules'
      specScript.id = scriptId
      const specRules = {
        prerender: [
          {
            source: 'document',
            where: {
              or: [
                { href_matches: `${basePath}/` },
                { href_matches: `${basePath}/jobs*` },
                { href_matches: `${basePath}/search*` },
                { href_matches: `${basePath}/(blogs|legal|login|privacy|welcome-video)/` },
              ],
            },
            eagerness: 'moderate',
          },
        ],
      }
      specScript.textContent = JSON.stringify(specRules)
      document.body.append(specScript)
      setLoaded(true)
    }
  }, [loaded])
  return <></>
}

export default SpeculationRules
